import Head from 'next/head'
import React from 'react'

interface Props {
  req: any
  data: any
}

const Test = ({ data }: Props) => {
  return (
    <div>
      <Head>
        <meta
          key="og:title"
          property="og:title"
          content="Boost your business' success with Elisops CRM & HRM software."
        />
        <meta
          key="og:description"
          property="og:description"
          content="Elisops offers the most innovative and cutting-edge solutions. Get customized software like CRM, HRM, and Logistics to meet your company's requirements."
        />
        <meta
          key="og:image"
          property="og:image"
          content="https://irhq-docs.s3.ap-southeast-2.amazonaws.com/Brookside/theme/1715664654271454.png"
        />
        <meta key="og:url" property="og:url" content="https://relait.brookside-energy.com.au/" />
        <meta key="og:type" property="og:type" content="website" />
      </Head>
      hello{data.title}
    </div>
  )
}

export default Test

export const getServerSideProps = async ({ req }: Props) => {
  return { props: { data: { title: 'respTitle' } } }
}
